import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { t } from 'i18next'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'

const OptionStatus = [
    { value: true, label: t('enable'), color: 'success' },
    { value: false, label: t('inactive'), color: 'info' },
]

export interface DomainVnis {
    domain: string
    cname: string
    wafEnable: boolean
    sslEnable: boolean
    enable: boolean
}

export const columns: GridColDefVNW<DomainVnis>[] = [
    {
        field: 'domain',
        headerName: 'domain',
        width: 250,
    },
    {
        field: 'cname',
        headerName: 'cName',
        width: 300,
    },
    {
        field: 'wafEnable',
        headerName: 'WAF',
        width: 150,
        renderCell: ({ value }) => {
            const status = OptionStatus.find((status) => status.value === value)
            return (
                <CellStatus
                    label={status?.label}
                    color={status?.color as Color}
                />
            )
        },
    },
    {
        field: 'sslEnable',
        headerName: 'SSL',
        width: 150,
        renderCell: ({ value }) => {
            const status = OptionStatus.find((status) => status.value === value)
            return (
                <CellStatus
                    label={status?.label}
                    color={status?.color as Color}
                />
            )
        },
    },
    {
        field: 'enable',
        headerName: 'Enable',
        width: 150,
        renderCell: ({ value }) => {
            const status = OptionStatus.find((status) => status.value === value)
            return (
                <CellStatus
                    label={status?.label}
                    color={status?.color as Color}
                />
            )
        },
    },
]

export default columns
